import backendClient from './backendClient';

export const createSharedGroceryLink = async () => {
  return backendClient.post('/api/mealplan/share', {}, { timeout: 5000 });
};

export const fetchSharedGroceryList = async (shareToken) => {
  return backendClient.get(`/api/mealplan/shared/${shareToken}`, { timeout: 5000 });
};

export const updateSharedGroceryState = async (shareToken, shoppingModeState) => {
  return backendClient.patch(
    `/api/mealplan/shared/${shareToken}`,
    { shoppingModeState },
    { timeout: 5000 }
  );
};